import React, { useState, useRef, useEffect } from "react";
import ExportProgress from "./ExportProgress";
import { Link } from "react-router-dom";
import { Row, Card, Col, Button, Modal, Container } from "react-bootstrap";
import { useAuth } from "../../../../context/AuthContext";
import { db } from "../../../../firebase";
import {
  setDoc,
  getDoc,
  updateDoc,
  doc,
  collection,
  getDocs,
  collectionGroup,
  where,
  query,
  orderBy,
  limit,
  Timestamp,
} from "firebase/firestore";
import {
  setEvent,
  eventTmp,
  paymentPrivilages,
  orderList,
  colorList,
  statusList,
  typeList,
  PatientLinkInfo,
  PatientDropDownForm,
  PatientTextInfo,
} from "../../Booking/BookingUtils";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import * as XLSX from "xlsx";

import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../../components/toast/SetToast";
import Toast from "../../../components/toast/SetToast";
import { connectStorageEmulator } from "firebase/storage";
import orderFormFields from "../../Sales/orderFormFields";

const CPAPTrial = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [exportError, setExportError] = useState("");
  const [exportProgress, setExportProgress] = useState(null);
  const exportInProgress = useRef(false);
  const { currentUser } = useAuth();

  const [nodeList, setNodeList] = useState([]);
  const [nodeIdDocs, setNodeIdDocs] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [customerAllList, setCustomerAllList] = useState([]);

  const [saleList, setSaleList] = useState([]);
  // const [activityList, setActivityList] = useState([]);
  // const [statusList, setStatusList] = useState([]);
  const nodeRef = useRef();
  const customerRef = useRef();
  const saleRef = useRef();

  const getSaleList = orderFormFields.find(
    (fieldData) => fieldData.label == "Sales Representative"
  );

  const buildQuery = (
    borrowingsCollectionGroupRef,
    start,
    end,
    node
    // customer,
    // sale
  ) => {
    let queryConstraints = [];
    queryConstraints.push(orderBy("BorrowDate"));
    const startDate = new Date(start);
    const endDate = new Date(end);

    const startDateTimestamp = Timestamp.fromDate(startDate);
    const endDateTimestamp = Timestamp.fromDate(endDate);
    queryConstraints.push(where("Activity", "==", "ยืมเครื่อง"));

    queryConstraints.push(where("BorrowDate", ">=", startDateTimestamp));
    queryConstraints.push(where("BorrowDate", "<=", endDateTimestamp));

    return query(borrowingsCollectionGroupRef, ...queryConstraints);
  };

  const onExport = async () => {
    if (exportInProgress.current) return;
    setExportError("");
    setExportProgress(null);
    if (startDate == null || endDate == null) {
      setExportError("Please select a start and end date.");
      return;
    }
    if (startDate > endDate) {
      setExportError("Start date must be on or before end date.");
      return;
    }
    const start = startDate;
    const end = endDate;
    const node = nodeRef.current.value;
    if (!node) {
      setExportError("Please wait for the node list to load and select a node.");
      return;
    }
    exportInProgress.current = true;
    setIsLoading(true);
    setExportProgress({ percent: 0, message: "Loading CPAP trial records..." });
    try {
      // const customer = customerRef.current.value;
      // const sale = saleRef.current.value;

      // Usage of the buildQuery function
      let borrowingsCollectionGroupRef = collection(db, "borrowings");
      // Pass your parameters here, including dates if searchTime is true
      let queryHandler = buildQuery(
        borrowingsCollectionGroupRef,
        start,
        end,
        node
        // customer,
        // sale
      );

      const tempTrial = [];
      const uniqueMap = new Map();

      const bookingRef = collectionGroup(db, "bookings");
      const docSnap = await getDocs(queryHandler);

      if (docSnap.empty) {
        console.log("No documents found");
      } else {
        // Reserve 5–50% for booking lookups and 50–95% for equipment lookups.
        // These percentages track processed records, not elapsed time.
        for (const [index, trial] of docSnap.docs.entries()) {
          setExportProgress({
            percent: 5 + Math.floor((index / docSnap.docs.length) * 45),
            message: `Checking trial records: ${index} / ${docSnap.docs.length}`,
          });
          const data = trial.data();
          const { SerialNumber, HN, FirstName, LastName } = data;

          // Ignore incomplete entries
          if (!SerialNumber || !HN || !FirstName) continue;

          const uniqueKey = `${SerialNumber}-${HN}`;

          // Skip if we've already processed this key
          if (uniqueMap.has(uniqueKey)) continue;

          const queryBookingRef = query(
            bookingRef,
            where("extendedProps.hn", "==", HN),
            // Match the existing descending collection-group index.
            orderBy("extendedProps.latestSleepStudyDate", "desc"),
            limit(1)
          );

          const bookingDocs = await getDocs(queryBookingRef);

          if (!bookingDocs.empty) {
            const latestBooking =
              bookingDocs.docs[0].data();

            if (node !== "All" && latestBooking.extendedProps.node !== node) {
              continue;
            }

            data.order = latestBooking.extendedProps.order;
            data.customer = latestBooking.extendedProps.customer;
            data.name =
              latestBooking.extendedProps.firstname +
              " " +
              latestBooking.extendedProps.lastname;
            data.refHospital = latestBooking.extendedProps.hospitalNumber;
          } else {
            if (node !== "All") {
              continue;
            }

            data.order = "";
            data.customer = "";
            data.name = `${FirstName} ${LastName}`;
            data.refHospital = "";
          }

          uniqueMap.set(uniqueKey, data);
        }

        // If you want the array version of the result
        tempTrial.push(...uniqueMap.values());
      }

      // Convert Map values back to an array
      const result = Array.from(uniqueMap.values());
      if (!result.length) {
        setExportProgress(null);
        setExportError("No CPAP trial records found for the selected dates and node.");
        return;
      }
      await createXLSX(result, start, end);
      setExportProgress({ percent: 100, message: "Export ready. Download started." });
    } catch (error) {
      setExportProgress(null);
      setExportError(`Unable to export CPAP Trial: ${error.message || "Please try again."}`);
    } finally {
      exportInProgress.current = false;
      setIsLoading(false);
    }
  };

  const formatDateRangeInThai = (startDateTimestamp, endDateTimestamp) => {
    const startDate = new Date(startDateTimestamp);
    const endDate = new Date(endDateTimestamp);

    const options = { year: "numeric", month: "long", day: "numeric" };
    const thaiFormatter = new Intl.DateTimeFormat("th-TH", options);

    const startDay = startDate.getDate();
    const startMonth = startDate.toLocaleString("th-TH", { month: "long" });
    const startYear = startDate.getFullYear();

    const endDay = endDate.getDate();
    const endMonth = endDate.toLocaleString("th-TH", { month: "long" });
    const endYear = endDate.getFullYear();

    if (startYear === endYear) {
      if (startMonth === endMonth) {
        return `${startDay} - ${endDay} ${startMonth} ${startYear}`;
      }
      return `${startDay} ${startMonth} - ${endDay} ${endMonth} ${startYear}`;
    }

    const formattedStartDate = thaiFormatter.format(startDate);
    const formattedEndDate = thaiFormatter.format(endDate);

    return `${formattedStartDate} - ${formattedEndDate}`;
  };

  const getThaiFormat = (date) => {
    // Check if the input is an object with 'seconds' and 'nanoseconds' properties (Firestore Timestamp)
    if (date) {
      if (
        date &&
        typeof date === "object" &&
        "seconds" in date &&
        "nanoseconds" in date
      ) {
        date = new Date(date.seconds * 1000); // Convert to JavaScript Date
      }

      // Check if the input is a Unix timestamp (number)
      if (typeof date === "number" || typeof date === "string") {
        date = new Date(date); // Convert Unix timestamp to JavaScript Date
      }

      if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";

      const options = { year: "numeric", month: "long", day: "numeric" };
      const thaiFormatter = new Intl.DateTimeFormat("th-TH", options);
      return thaiFormatter.format(date);
    } else {
      return "";
    }
  };

  const createXLSX = async (trial, start, end) => {
    const rangeDate = formatDateRangeInThai(start, end);
    const headerText = [
      rangeDate,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    const headers = [
      "ลำดับ",
      "วันที่ยืม",
      "วันที่ครบกำหนดคืน",
      "วันที่คืน",
      "Sleep Study No.",
      "โรงพยาบาลผู้ส่งตรวจ",
      "ชื่อ - นามสกุล",
      "รหัสโรงพยาบาล",
      "Serial Number",
      "CPAP ID",
      "Brand",
      "Model",
      "Mask",
      "Size",
      "ReturnCondition",
      "Note",
      "Sale",
    ];

    headerText.push("");
    const data = [headerText, headers];

    const bookingRef = collectionGroup(db, "bookings");
    const cpapRef = collection(db, "cpaps");
    const trialRef = collection(db, "trial");

    for (const [index, borrow] of trial.entries()) {
      setExportProgress({
        percent: 50 + Math.floor((index / trial.length) * 45),
        message: `Preparing export rows: ${index} / ${trial.length}`,
      });
      const row = [];

      row.push(index + 1);
      row.push(getThaiFormat(borrow.BorrowDate));
      row.push(getThaiFormat(borrow.DueDate));
      row.push(getThaiFormat(borrow.ReturnDate));

      // const queryBookingRef = query(
      //   bookingRef,
      //   where("extendedProps.hn", "==", borrow.HN),
      //   orderBy("extendedProps.latestSleepStudyDate")
      // );
      // const bookingDocs = await getDocs(queryBookingRef);
      // if (!bookingDocs.empty) {
      //   const booking = bookingDocs.docs[bookingDocs.docs.length - 1].data();
      //   row.push(booking.extendedProps.order);
      //   row.push(booking.extendedProps.customer);
      //   row.push(
      //     booking.extendedProps.firstname + " " + booking.extendedProps.lastname
      //   );
      //   row.push(booking.extendedProps.hospitalNumber);
      // } else {
      //   console.log("empty: ", borrow);
      //   row.push("");
      //   row.push("");
      //   row.push(borrow.FirstName + " " + borrow.LastName);
      //   row.push("");
      // }
      row.push(borrow.order);
      row.push(borrow.customer);
      row.push(borrow.name);
      row.push(borrow.refHospital);

      const queryCpapRef = query(
        cpapRef,
        where("SerialNumber", "==", borrow.SerialNumber)
      );
      // Use the same patient/device trial assignment as the dashboard.
      const queryTrialRef = query(
        trialRef,
        where("extendedProps.HN", "==", borrow.HN),
        where("extendedProps.SerialNumber", "==", borrow.SerialNumber),
        orderBy("start", "desc"),
        limit(1)
      );
      const [cpapDocs, trialDocs] = await Promise.all([
        getDocs(queryCpapRef),
        getDocs(queryTrialRef),
      ]);
      if (!cpapDocs.empty) {
        const cpap = cpapDocs.docs[0].data();
        // console.log(cpap);
        row.push(cpap.SerialNumber);
        row.push(cpap.CpapID);
        row.push(cpap.Brand);
        row.push(cpap.Model);
        row.push(cpap.Mask);
        row.push(cpap.Size);
        row.push(cpap.ReturnCondition);
        row.push(cpap.Note);
      } else {
        row.push("");
        row.push("");
        row.push("");
        row.push("");
        row.push("");
        row.push("");
        row.push("");
        row.push("");
      }

      const trialProps = !trialDocs.empty
        ? trialDocs.docs[0].data().extendedProps || {}
        : {};
      row.push(trialProps.sale || "");
      data.push(row);
    }

    setExportProgress({ percent: 95, message: "Preparing Excel file..." });
    // Let the browser paint the final stage before synchronous workbook creation.
    await new Promise((resolve) => setTimeout(resolve, 0));
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "CPAP Trial");
    XLSX.writeFile(wb, `CPAP Trial ${rangeDate}.xlsx`);
  };

  useEffect(() => {
    fetchAnotherData();
  }, []);

  const fetchAnotherData = async () => {
    try {
      // Use Promise.all for parallel fetching
      const [nodesDocs] = await Promise.all([getDocs(collection(db, "nodes"))]);

      let allCustomers = [];
      let allnodeIdDocs = [];
      let allNodes;
      if (
        ["super_admin", "sale", "accountant"].includes(
          currentUser.roles[0],
        )
      ) {
        allNodes = nodesDocs.docs.map((doc) => doc.data().nodename);
        for (const nodeDoc of nodesDocs.docs) {
          allnodeIdDocs = [...allnodeIdDocs, nodeDoc.id];
          const customerDocs = await getDocs(
            collection(db, "nodes", nodeDoc.id, "customers")
          );
          const customersData = customerDocs.docs.map((customer) => {
            const customerData = customer.id;
            return customerData;
          });
          allCustomers.push(customersData);
        }
      } else if (currentUser.roles[0] == "sleep_physician") {
        allNodes = nodesDocs.docs.map((doc) => doc.data().nodename);
        for (const nodeDoc of nodesDocs.docs) {
          allnodeIdDocs = [...allnodeIdDocs, nodeDoc.id];
          const customerDocs = await getDocs(
            collection(db, "nodes", nodeDoc.id, "customers")
          );
          const customersData = customerDocs.docs.map((customer) => {
            const customerData = customer.id;
            return customerData;
          });
          allCustomers.push(customersData);
        }
      } else {
        // allNodes = nodesDocs.docs.map((doc) => doc.data().nodename);
        const currentAdmin = await getDoc(
          doc(db, "admins", currentUser.displayName)
        );
        let nodeCode = currentAdmin.data().node;
        // Ensure `nodeCode` is always an array
        if (!Array.isArray(nodeCode)) {
          nodeCode = nodeCode ? [nodeCode] : []; // Convert to array or set to empty
        }

        // Find matching nodes
        const node = nodesDocs.docs.filter((doc) =>
          nodeCode.includes(doc.data().nodecode)
        );

        allnodeIdDocs = node.map((doc) => doc.id);
        allNodes = node.map((doc) => doc.data().nodename);

        for (const id of allnodeIdDocs) {
          const customerDocs = await getDocs(
            collection(db, "nodes", id, "customers")
          );
          const customersData = customerDocs.docs.map((customer) => {
            const customerData = customer.id;
            return customerData;
          });
          allCustomers.push(customersData);
        }
      }
      setCustomerAllList(["All", ...allCustomers]);
      setCustomerList(["All", ...(allCustomers[0] || [])]);
      setNodeList(["All", ...allNodes]);
      setNodeIdDocs(["All", ...allnodeIdDocs]);

      setSaleList(["All", ...getSaleList.options]);
      // setActivityList(["All", ...getActivityList.options]);
      // setStatusList(["All", ...getStatusList.options]);
    } catch (error) {
      setExportError(`Unable to load export filters: ${error.message || "Please reload and try again."}`);
    }
  };

  const CustomerList = (nodename) => {
    const index = nodeList.indexOf(nodename);
    return ["All", ...customerAllList[index]];
  };

  return (
    <>
        <div className="col-lg-12 mb-5">
          <b>CPAP Trial</b>

          {exportError && <div className="alert alert-warning mt-3" role="alert">{exportError}</div>}

          <div className="col-xl-9 col-lg-12 mt-4">
            <fieldset disabled={isLoading}>
            <div className="form-group row">
              <label className="col-lg-3 col-form-label">
                {"Range Date"}
                <span className="text-danger"></span>
              </label>
              <div className="row ml-1">
                <div className="col-lg-3">
                  <DatePicker
                    className="form-control"
                    selected={startDate}
                    onChange={(date) => setStartDate(date ? date.setHours(0, 0, 0, 0) : null)}
                    disabled={isLoading}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    minDate={null}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/MM/yyyy"
                    // todayButton={true}
                  />
                </div>
                <div className="mt-3">-</div>
                <div className="col-lg-3">
                  <DatePicker
                    className="form-control"
                    selected={endDate}
                    onChange={(date) =>
                      setEndDate(date ? date.setHours(23, 59, 59, 999) : null)
                    }
                    disabled={isLoading}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/MM/yyyy"
                    todayBtn={true}
                  />
                </div>
              </div>
            </div>
            <PatientDropDownForm
              title="Node"
              id="node-sale"
              refvalue={nodeRef}
              // selected={currentBooking.extendedProps.node}
              options={nodeList}
              onChange={(e) => {
                setCustomerList(CustomerList(e.target.value));
              }}
            ></PatientDropDownForm>
            {/* <PatientDropDownForm
              title="Customer"
              id="customer-sale"
              refvalue={customerRef}
              // selected={currentBooking.extendedProps.customer}
              options={customerList}
            ></PatientDropDownForm> */}
            {/* <PatientDropDownForm
              title="Sale"
              id="sale-sale"
              refvalue={saleRef}
              // selected={currentBooking.extendedProps.customer}
              options={saleList}
            ></PatientDropDownForm> */}
            <Button onClick={onExport} disabled={isLoading || !nodeList.length}>
              {isLoading ? `Exporting ${exportProgress ? exportProgress.percent : 0}%...` : "Export"}
            </Button>
            </fieldset>
            <ExportProgress progress={exportProgress} isExporting={isLoading} label="CPAP Trial" />
          </div>
        </div>
    </>
  );
};

export default CPAPTrial;
